import ApplicationSerializer from 'cio/serializers/application';

export default ApplicationSerializer.extend({
  normalize(type, hash, prop) {
    // temporary mock ID, since back-end doesn't return it in its response
    // (note: there's always only one tax-rate object, so it can be a static hard-coded value)
    hash.id = 'current';

    return this._super(type, hash, prop);
  },
});
